import { useQuery } from '@tanstack/react-query'

import { encodeQueryString } from '../../../../app/queryString'
import { apiRequest } from '../../../services/api'
import { ApiPaginatedResponse } from '../../../types'
import { DEFAULT_QUERY_CACHE_TIME_IN_MS, ManagerHolding } from '../constants'

interface Props {
  id: number | string
  reportEndDate?: string
  page: number
  sort?: string
  initialData?: ApiPaginatedResponse<ManagerHolding[]> | null
  shouldResetScroll?: boolean
}

export function useManagerHoldingsData({ id, reportEndDate, page, sort, initialData, shouldResetScroll }: Props) {
  const managerHoldingsQuery = useQuery({
    queryKey: ['managerHoldings', id, page, sort],
    queryFn: async () =>
      apiRequest<ApiPaginatedResponse<ManagerHolding[]>>(
        `/api/managers/${id}/holdings?${encodeQueryString({ reportEndDate, page, sort })}`
      ),
    initialData: initialData ?? undefined,
    onSuccess: () => {
      if (shouldResetScroll) {
        window.scrollTo({ top: 0 })
      }
    },
    keepPreviousData: true,
    staleTime: DEFAULT_QUERY_CACHE_TIME_IN_MS,
    cacheTime: DEFAULT_QUERY_CACHE_TIME_IN_MS,
  })

  return managerHoldingsQuery
}
